import { Config } from "./parts/vars/types";

export const config: Config = {
  triggerPos: {
    pc: "80%",
    sp: "90%",
  },
  breakPoint: 760,
  headerHidingPoint: 100,
  newsUrl: "https://note.com/hiroshima_sb/m/m5b0f5cc2b371/rss",
};
